module.exports = __webpack_public_path__ + "img/SSS-M-13.21478681.svg";